module.exports = __webpack_public_path__ + "static/media/success-set.2456a95a.png";